import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { login, signout } from "../actions/auth_action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const useAuthManager = () => {
  const {
    isLoading,
    isAuthenticated,
    getAccessTokenSilently,
    logout: auth0Logout,
    user,
  } = useAuth0();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [isLogingin, setIsLogingin] = useState(false);

  const getAccessToken = async () => {
    if (isAuthenticated) {
      try {
        const token = await getAccessTokenSilently();
        return token;
      } catch (error) {
        // console.error("❌ getAccessTokenSilently failed:", error);
      }
    } else {
      // console.warn("⚠️ Tried getting token when not authenticated");
    }
    return null;
  };

  const logout = () => {
    localStorage.clear();
    dispatch(signout());

    auth0Logout({ localOnly: true });
    navigate("/signin");
  };

  useEffect(() => {
    // console.log("%c[Auth Debug]", "color: teal; font-weight: bold;");
    // console.log("isLoading:", isLoading);
    // console.log("isAuthenticated (Auth0):", isAuthenticated);
    // console.log("isLoggedIn (Redux):", isLoggedIn);
    // console.log("✅ isAuthenticated:", isAuthenticated);
    // console.log("👤 User:", user);

    if (isLoading) return;

    if (isAuthenticated && !isLoggedIn) {
      const run = async () => {
        const access_token = await getAccessToken();
        // console.log("Access Token:", access_token);

        if (!access_token) {
          console.warn("[AuthManager] No access token available.");
          return;
        }

        setIsLogingin(true);
        dispatch(login(access_token, navigate));
        setIsLogingin(false);
      };

      run().catch((err) => {
        console.error("Error during login dispatch:", err);
        // logout();
      });
    }
  }, [isLoading, isAuthenticated, isLoggedIn, dispatch]);

  return {
    isLoading: isLoading || isLogingin,
    isAuthenticated: isAuthenticated && isLoggedIn,
    getAccessToken,
    logout,
  };
};
